import { useStateSelector } from '../store/selectors';
import { FeatureFlagsEnum } from '../containers/FeatureFlags/FeatureFlags.enum';
import { FeatureFlagModel } from '../containers/FeatureFlags/FeatureFlagContract.model';

export const useFeatureFlag = (key: FeatureFlagsEnum): boolean => {
    const featureFlags: FeatureFlagModel[] = useStateSelector(
        (s) => s.userSummary.summary.featureFlags
    );
    return featureFlags.some((f) => f.key === key && f.isEnabled);
};
